import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { onGetOne } from 'redux/actions/reservations.actions';

import LayoutContainer from 'containers/LayoutContainer';
import ReservationsShow from 'views/public/ReservationsView/components/ReservationsShow';

import Loading from 'components/commons/Loading';

import 'views/public/ReservationsView/components/ReservationsShow/i18n';

const ReservationsShowContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { id = '' } = useParams<{ id?: string }>();
  const { loading, selectedItem: item } = useTypedSelector((state) => state.reservations);

  useEffect(() => {
    if (id) dispatch(onGetOne(id));
    return () => {
      dispatch(onGetOne(''));
    };
  }, [dispatch, id]);

  return (
    <LayoutContainer isPublic title={i18next.t<string>('PUBLIC_PROCEDURES_VIEW:TITLE')}>
      <ReservationsShow item={item} />
      {loading && <Loading isModalMode message={i18next.t('RESERVATIONS_SHOW:LOADING')} />}
    </LayoutContainer>
  );
};

export default ReservationsShowContainer;
